import { Link } from 'react-router'
import { Home } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
    const { t } = useTranslation()

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-50 to-brand-100">
            {/* SEO por rota — no React 19 estas tags são içadas para o <head> */}
            <title>{t('notFound.metaTitle')}</title>
            <meta name="description" content={t('notFound.metaDescription')} />
            <meta name="robots" content="noindex" />
            <div className="text-center px-6">
                <h1 className="text-9xl font-bold text-brand-600 mb-4" translate="no">404</h1>
                <h2 className="text-3xl font-bold text-slate-900 mb-4">
                    {t('notFound.title')}
                </h2>
                <p className="text-lg text-slate-600 mb-8 max-w-md mx-auto">
                    {t('notFound.body')}
                </p>
                <Link
                    to="/"
                    className="btn-primary inline-flex items-center gap-2"
                >
                    <Home size={20} aria-hidden="true" />
                    {t('notFound.home')}
                </Link>
            </div>
        </div>
    )
}
